import { type HTMLAttributes, type Ref } from "react";

import { cn } from "../../lib/utils";

export interface ItemGroupProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

// No role="list" here: that ARIA role requires every child to be role="listitem", which Item
// doesn't set (Item is also used standalone, outside any group, where listitem semantics would
// be wrong) -- axe's aria-required-children rule correctly flags the mismatch otherwise.
export const ItemGroup = ({ className, ref, ...props }: ItemGroupProps) => (
  <div ref={ref} data-slot="item-group" className={cn("group/item-group flex flex-col", className)} {...props} />
);
